import { render, staticRenderFns } from "./card-list.vue?vue&type=template&id=601a8b0a&scoped=true"
import script from "./card-list.vue?vue&type=script&lang=js"
export * from "./card-list.vue?vue&type=script&lang=js"
import style0 from "./card-list.vue?vue&type=style&index=0&id=601a8b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a8b0a",
  null
  
)

export default component.exports